import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const Layout = ({ children }) => {
  const location = useLocation();
  const isStudentStory = location.pathname.startsWith('/story/');

  return (
    <div className="min-h-screen bg-gray-50">
      {!isStudentStory && <Header />}
      <main className={!isStudentStory ? 'pt-16' : ''}>
        {children}
      </main>
    </div>
  );
};

export default Layout;